import { render, staticRenderFns } from "./Lyricists.vue?vue&type=template&id=1860f0af&"
import script from "./Lyricists.vue?vue&type=script&lang=js&"
export * from "./Lyricists.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports